import React from 'react';
import Header from '../../Header';
import styles from './style.css';

class ManageRecipientAlertEmail extends React.Component {
  render() {
    return (
      <div>
        <Header title="manage recipient alert email" />
        <p className={styles.description}>
          Email notification will only be sent to recipient that already{' '}
          <b>verified</b> their email. Please check your email inbox or SPAM
          folder and make sure to mark us as not spam sender to receive our
          email notifications.
        </p>
      </div>
    );
  }
}

export default ManageRecipientAlertEmail;
